import { ArrowDropDownIcon, ArrowDropUpIcon } from 'tuui';
import styles from './rangePickerHeader.module.scss';

const fullFormat = 'MMM D, YYYY';
const shortFormat = 'MMM D';

export const RangePickerHeader = ({ startDate, endDate, togglePicker, pickerOpen, preset, className }) => {
    const startFormat = startDate.year() !== endDate.year() ? fullFormat : shortFormat;
    const dateRangeContainerClassName = className || styles['date-range-container'];

    return (
        <div className={styles['range-picker-container']} onClick={togglePicker}>
            <div className={styles['preset-container']}>{preset}</div>
            <div className={dateRangeContainerClassName}>
                {`${startDate.format(startFormat)} - ${endDate.format(fullFormat)}`}
                <div className={styles['dropdown-icon']}>
                    {pickerOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </div>
            </div>
        </div>
    );
};
